import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Id', prop: 'id' },
  { title: 'Program', prop: 'program_id', references: 'admin/programs', referenceProp: 'name' },
  { title: 'Timer Type', prop: 'timer_type_id', references: 'admin/timer_types', referenceProp: 'timer_type' }
]

const filters = [
  { name: 'Filter by program', prop: 'filters.program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name', enabled: true },
  { name: 'Filter by timer type', prop: 'filters.timer_type_id', type: 'autocomplete', references: 'admin/timer_types', referenceProp: 'timer_type', enabled: true }
]

const defaults = {
  order: [{ column: 'id', direction: 'desc' }]
}

const Members = (props) => (
  <List
    title='Program Timers'
    apiPath='admin/program_timer_types'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Members
